import { render, staticRenderFns } from "./ChopForm.vue?vue&type=template&id=7352dec1&scoped=true&"
import script from "./ChopForm.vue?vue&type=script&lang=js&"
export * from "./ChopForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7352dec1",
  null
  
)

export default component.exports